// Ellipsis larger text to fit in a given width
export const ellipsisText = (text: string, length: number) => {
  const checkLength = text?.length > length
  const ellipsisText = checkLength ? `${text?.substring(0, length)}...` : text

  return {
    text: ellipsisText,
    checkLength: checkLength,
  }
}
